<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center"> Histórico de Equipos Asignados </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="end" align="center">
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    class="transparent"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.equipoAsignado`]="{ item }">
                      <span v-if="Array.isArray(item.equipoAsignado)">
                        {{ item.equipoAsignado.map((eq) => eq.Equipo?.CatItem?.item || '').join(', ') }}
                      </span>
                      <span v-else>
                        {{ item.equipoAsignado }}
                      </span>
                    </template>
                    <template v-slot:[`item.file`]="{ item }">
                      <a v-if="item.file" :href="item.file" target="_blank">{{ item.file }}</a>
                      <span v-else>No hay archivo</span>
                    </template>
                    <template v-slot:[`item.acciones`]="{ item }">
                      <v-btn icon color="secondary" small v-if="item.file" :href="item.file" download>
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-text-box-search-outline"
                                @click="openListadoEquiposAsignadosDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Listado de Equipos Asignados</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import IconButton from '@/components/base/IconButton.vue'

export default {
  components: {
    IconButton,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Fecha de Solicitud', value: 'fechaSolicitud' },
        { text: 'Fecha de Asignación', value: 'fechaAsignacion' },
        { text: 'Folio de Resguardo', value: 'folioResguardo' },
        { text: 'Archivo', value: 'file' },
        { text: 'Equipo seleccionado', value: 'equipoAsignado' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('asignacionEquipo', {
      asignacionesEquipo: 'getAsignacionesEquipo',
    }),
    items() {
      return this.asignacionesEquipo.filter((a) => a.fk_idPersonal === this.id)
    },
  },
  mounted() {
    this.fetchAsignacionEquipoByPersonal(this.id)
  },
  methods: {
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    openListadoEquiposAsignadosDialog(item) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.LISTADO_EQUIPOS_ASIGNADOS,
        props: {
          asignacionEquipo: item,
        },
      })
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para HistoricoEquipoAsignado */
.card {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
.v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(255, 159, 67, 0.15) 0%, rgba(255, 159, 67, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(255, 159, 67, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(255, 159, 67, 0.1) !important;
  transform: scale(1.005);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(255, 159, 67, 0.1) !important;
  padding: 16px !important;
}

/* Enlaces */
a {
  color: #ff9f43 !important;
  text-decoration: none;
  transition: all 0.3s ease;
}

a:hover {
  color: #ffbe76 !important;
  text-decoration: underline;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

::v-deep .v-btn:hover::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.3);
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #ff9f43 0%, #ffbe76 100%) !important;
  color: #ffffff !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

::v-deep .v-btn:hover .v-icon {
  color: #ffffff !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(46, 36, 22, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 159, 67, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #e0e0e0 !important;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(255, 159, 67, 0.2) !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
